var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcInfoTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9629 51.75C54.9629 52.992 53.9549 54 52.7129 54H7.71289C3.99139 54 0.962891 50.9715 0.962891 47.25V2.25C0.962891 1.008 1.97089 0 3.21289 0C4.45489 0 5.46289 1.008 5.46289 2.25V47.25C5.46289 48.4897 6.47314 49.5 7.71289 49.5H52.7129C53.9549 49.5 54.9629 50.508 54.9629 51.75ZM48.2129 11.25H39.2129C37.9709 11.25 36.9629 12.258 36.9629 13.5C36.9629 14.742 37.9709 15.75 39.2129 15.75H47.2296L36.3014 26.3407C35.4531 27.1912 33.9704 27.1912 33.1221 26.3407C33.0299 26.2507 30.3344 24.3315 30.3344 24.3315C27.7739 21.9172 23.4111 22.0072 20.9699 24.4462L10.6514 34.3778C9.75589 35.2395 9.72889 36.6638 10.5906 37.5592C11.0339 38.0183 11.6211 38.25 12.2129 38.25C12.7754 38.25 13.3379 38.0408 13.7721 37.6223L24.1221 27.6593C24.9704 26.8088 26.4531 26.8088 27.3014 27.6593C27.3936 27.7493 30.0891 29.6685 30.0891 29.6685C32.6519 32.085 37.0101 31.9995 39.4581 29.547L50.4606 18.882V26.9977C50.4606 28.2397 51.4686 29.2477 52.7106 29.2477C53.9526 29.2477 54.9606 28.2397 54.9606 26.9977V17.9977C54.9606 14.2762 51.9321 11.2478 48.2106 11.2478L48.2129 11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcInfoTrendingUp);
export default __webpack_public_path__ + "static/media/edc-info-trending-up.59380d2b29bd647b99c61881d4821ae2.svg";
export { ForwardRef as ReactComponent };